import PropTypes from 'prop-types'
import { MaskedInput } from 'baseui/input'
import { mergeOverrides } from 'baseui'
import { SMaskedInputOverrides } from './styled-components'
import { Alert, Delete } from 'baseui/icon'
import IconCarbonCheckmarkOutline from '@/shared/icons/IconCarbonCheckmarkOutline'
import InfoIcon from '../icon_info.svg'
import { useEffect, useState } from 'react'
import { EnhancerRow, FloatingLabel, RelativeContainer } from '@/shared/theme/styled-components'

const StatusEnhancer = ({ icon }) => <div className='sdinput-end-enhancer'>{icon}</div>
StatusEnhancer.propTypes = { icon: PropTypes.node }

const StatusWithExtraEnhancer = ({ icon, extra }) => (
  <EnhancerRow>
    <div className='sdinput-end-enhancer'>{icon}</div>
    {extra}
  </EnhancerRow>
)
StatusWithExtraEnhancer.propTypes = { icon: PropTypes.node, extra: PropTypes.node }

const resolveEndEnhancer = (icon, enhancerProp) => {
  if (!icon) return enhancerProp ?? null
  if (!enhancerProp) return <StatusEnhancer icon={icon} />
  return <StatusWithExtraEnhancer icon={icon} extra={enhancerProp} />
}

const SDMaskedInput = ({ label, overrides, status, currentValue, onBlur, error, ...rest }) => {
  const [value, setValue] = useState(currentValue || null)

  const iconMapping = {
    valid: <IconCarbonCheckmarkOutline size={24} color='green' />,
    info: <img src={InfoIcon} alt='Info' style={{ width: 24, height: 24 }} />,
    warning: <Alert size={24} color='orange' />,
    error: <Delete size={24} color='red' />,
  }

  const statusIcon = status && iconMapping[status] ? iconMapping[status] : null

  const endEnhancer = resolveEndEnhancer(statusIcon, rest.endEnhancer)

  const hasEndEnhancer = !!endEnhancer
  const newOverrides = mergeOverrides(SMaskedInputOverrides(error || false, hasEndEnhancer), overrides)

  useEffect(() => {
    if (currentValue === null || currentValue === undefined) {
      setValue('')
      return
    }
    setValue(currentValue)
  }, [currentValue])

  return (
    <RelativeContainer>
      {label && (
        <FloatingLabel>
          <div dangerouslySetInnerHTML={{ __html: label }} />
        </FloatingLabel>
      )}
      <MaskedInput
        {...rest}
        error={error}
        overrides={newOverrides}
        onBlur={e => {
          if (typeof onBlur === 'function') {
            let selectedValue = e.target.value
            if (selectedValue === '') {
              selectedValue = null
            }
            onBlur(selectedValue)
          }
        }}
        onChange={e => setValue(e.target.value)}
        endEnhancer={endEnhancer}
        value={value}
      />
    </RelativeContainer>
  )
}

SDMaskedInput.propTypes = {
  label: PropTypes.node,
  overrides: PropTypes.object,
  status: PropTypes.oneOf(['valid', 'info', 'warning', 'error']),
  currentValue: PropTypes.any,
  onBlur: PropTypes.func,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
}

export default SDMaskedInput
